module.exports = __webpack_public_path__ + "media/images/icons/icon-product_4-87857bc2bcb1490e5c3f21376f4dca42.svg";